module.exports = "<section class=\"mat-typography cao-content\">\n  <app-li-chess-player></app-li-chess-player>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /workspace/chess.arska.org/chess/src/app/profile/profile.component.html
// module id = ../../../../../src/app/profile/profile.component.html
// module chunks = main